import { IconProps } from "./";
import Icon from "./assets/google_drive_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24GoogleDrive(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
